export default __webpack_public_path__ + "static/media/06.8bf41973.png";